import React from 'react';
import { Instagram, Phone, Mail } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-4" style={{ background: 'linear-gradient(to top, #0A0015, #1A0520)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold text-neon-pink neon-text mb-4" style={{ 
              fontFamily: "'Great Vibes', cursive",
              WebkitTextStroke: '1.5px white',
              paintOrder: 'stroke fill'
            }}>
              Saale Lounge
            </h3>
            <p className="text-white/70 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Dein Premium Lounge-Erlebnis in Hammelburg
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Quick Links
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#lounge-section" className="text-white/70 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Saale Lounge
              </a>
              <a href="#beach-section" className="text-white/70 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Saale Beach
              </a>
              <a href="#menu" className="text-white/70 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Karte Lounge
              </a>
              <a href="#beach-menu" className="text-white/70 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Karte Beach
              </a>
              <a href="#reservation" className="text-white/70 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Reservierung
              </a>
              <a href="#contact" className="text-white/70 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Kontakt
              </a>
              <a href="#impressum" className="text-white/70 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Impressum
              </a>
            </div>
          </div>
          
          {/* Social */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Folge uns
            </h4>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/saale_lounge?igsh=MXNtdWVoZHR5NjczNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-neon-pink/20 flex items-center justify-center hover:bg-neon-pink/40 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-neon-pink" />
              </a>
              <a 
                href={`https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-deep-violet/20 flex items-center justify-center hover:bg-deep-violet/40 transition-colors"
                aria-label="WhatsApp"
              >
                <Phone className="w-5 h-5 text-deep-violet" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-neon-pink/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              © {currentYear} Saale Lounge. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6">
              <a href="#impressum" className="text-white/60 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Impressum
              </a>
              <a href="#" className="text-white/60 hover:text-neon-pink transition-colors text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
